import {HttpInterceptorFn} from '@angular/common/http';
import {environment} from '../../../environments/environment';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  let token = localStorage.getItem('accessToken');

  if (req.url.includes(environment.rootUrl)) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    token = user?.jwt_token?.[0] || token;
  }

  const authReq = req.clone({
    headers: req.headers
      .set('Authorization', 'Bearer ' + token)
      .set('Access-Control-Allow-Private-Network', 'true')
      .set('Access-Control-Allow-Origin', '*')
      .set('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
      .set('Access-Control-Request-Private-Network', 'true'),
  });

  return next(authReq);
};
